import { ArrowLeft, ArrowRight, Check, CreditCard } from "lucide-react"
import { Button } from "../ui/button"
import { useFormStore } from "@/stores/use-form-store"
import { useLogicStore } from "@/stores/use-conditional-logic-store"

interface FormActionsProps {
	isPreview: boolean
	isFirstStage: boolean
	isLastStage: boolean
	handlePrevious?: () => void
	handleNext?: () => void
	isSubmitting: boolean
	isSubmitted: boolean
	isDisabled?: boolean
}

export const FormActions = ({
	isPreview = true,
	isFirstStage = true,
	isLastStage = true,
	handleNext,
	handlePrevious,
	isSubmitting = false,
	isSubmitted = false,
	isDisabled = false,
}: FormActionsProps) => {
	const { shouldDisable } = useFormStore()
	const {
		errors,
		resetErrors,
		resetFieldSectionMap,
		resetSectionFieldCount,
		resetHiddenFields,
	} = useLogicStore()
	const hasManualErrors = Object.keys(errors).length > 0

	return (
		<div className="flex flex-col items-center justify-between gap-4 @xl:flex-row">
			{!isFirstStage && (
				<Button
					type="button"
					variant="outline"
					onClick={() => {
						resetErrors()
						resetHiddenFields()
						resetSectionFieldCount()
						resetFieldSectionMap()
						if (handlePrevious) handlePrevious()
					}}
					disabled={isSubmitting || isDisabled}
					className="gap-2 bg-transparent"
					size={"lg"}
				>
					<ArrowLeft className="h-4 w-4" />
					Previous Step
				</Button>
			)}

			{isLastStage && (
				<Button
					type="submit"
					disabled={
						isPreview ||
						isSubmitting ||
						isSubmitted ||
						shouldDisable ||
						hasManualErrors ||
						isDisabled
					}
					className="gap-2"
					size="lg"
				>
					{isSubmitting ? (
						<>
							<div className="h-4 w-4 animate-spin rounded-full border-b-2 border-white" />
							Submitting...
						</>
					) : isSubmitted ? (
						<>
							<Check className="h-4 w-4" />
							Submitted
						</>
					) : (
						<>
							<CreditCard className="h-4 w-4" />
							Submit
						</>
					)}
				</Button>
			)}

			{!isLastStage && (
				<Button
					type={isPreview ? "button" : "submit"}
					onClick={() => {
						if (isPreview) {
							handleNext?.()
						}
					}}
					className="gap-2"
					size="lg"
					disabled={isSubmitting || hasManualErrors || isDisabled}
				>
					<>
						Next Step
						<ArrowRight className="h-4 w-4" />
					</>
				</Button>
			)}
		</div>
	)
}
